import styled from "styled-components";

export const Container = styled.div`
  p {
    margin: 0;
  }

  ul,
  ol {
    padding-left: 1.25rem;
    margin: 8px 0;
  }

  li {
    margin-bottom: 6px;
  }

  strong {
    font-weight: bold;
  }

  a {
    color: var(--blue-400);
    text-decoration: underline;
    word-break: break-word;
  }

  pre {
    background-color: var(--white-25);
    padding: 10px;
    border-radius: 8px;
    overflow-x: auto;
    font-size: 13px;
  }

  iframe {
    margin-top: 12px;
    width: 100%;
    height: 15.6rem;
    border: none;
    border-radius: 8px;
  }

  h1,
  h2,
  h3,
  h4 {
    margin: 10px 0 6px;
    font-weight: bold;
  }
`;
